import { Text } from '@mantine/core'
import { ContextModalProps, modals } from '@mantine/modals'
import ShortageForm from 'components/shortage/ShortageForm'
import { useAddShortage } from 'hooks/shortage'
import { useIsVariantAvailable } from 'hooks/variants'
import { NewShortage } from 'types/shortage'

export default function AddShortageModal({ context, id }: ContextModalProps) {
  const addShortage = useAddShortage()
  const isVariantAvailable = useIsVariantAvailable()

  function openBypassAvailabilityCheckModal(values: NewShortage) {
    modals.openConfirmModal({
      title: 'Produkt jest dostępny',
      children: (
        <Text size="sm">
          Produkt który próbujesz dodać do braków jest dostępny na magazynie. Czy na pewno chcesz dodać ten brak?
        </Text>
      ),
      labels: { confirm: 'Tak', cancel: 'Nie' },
      onConfirm: async () => await addShortage.mutateAsync(values),
      onCancel: () => context.closeModal(id),
      centered: true,
    })
  }

  return (
    <ShortageForm
      onSubmit={async (values: NewShortage) => {
        const isAvailable = await isVariantAvailable.mutateAsync(values)
        if (isAvailable) {
          openBypassAvailabilityCheckModal(values)
          return
        }
        await addShortage.mutateAsync(values)
      }}
      onCancel={() => context.closeModal(id)}
    />
  )
}
